// extracted by mini-css-extract-plugin
export default {"content":"MightyCPage--content--1Z8Df"};